import type {ReactElement} from 'react'

import {DockedPanel} from '../../contexts/DockedPanelContext'

import {AlertsSidePanel} from './AlertsSidePanel'
import {CommentsSidePanel} from './CommentsSidePanel'
import {CopilotChatSidePanel} from './CopilotChatSidePanel'
import {ManageBatchPanel} from './ManageBatchPanel'
import {MergeStatusPanel} from './MergeStatusPanel'
import {OverviewTimelinePanel} from './OverviewTimelinePanel'
import {OverviewSidePanel} from './OverviewSidePanel'

/**
 * Maps each docked panel id to the component that renders its body.
 *
 * Kept in a separate module from `panel-registry.tsx` so that consumers of
 * panel metadata do not transitively import every panel's module graph.
 *
 * When the Overview preview is not enabled, the Comments panel is rendered as a child of
 * `OpenCommentsPanelButton` (so it inherits `PullRequestStoreProvider`
 * scope) and portals into the docked panel target. `DockedSidePanelContent`
 * suppresses its own render of Comments in that case to avoid
 * double-mounting.
 */
export function renderActivePanel(id: DockedPanel): ReactElement | null {
  switch (id) {
    case DockedPanel.Alerts:
      return <AlertsSidePanel />
    case DockedPanel.Comments:
      return <CommentsSidePanel />
    case DockedPanel.CopilotChat:
      return <CopilotChatSidePanel />
    case DockedPanel.MergeStatus:
      return <MergeStatusPanel />
    case DockedPanel.Overview:
      return <OverviewSidePanel />
    case DockedPanel.Timeline:
      return <OverviewTimelinePanel />
    case DockedPanel.ManageBatchReviewComments:
      return <ManageBatchPanel />
  }
}
